// components/chat/MessageAvatar.js
import React from 'react';
import './MessageAvatar.css';

const MessageAvatar = ({ role }) => {
  return (
    <div className="message-avatar">
      {role === 'assistant' ? (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
          <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
          <path d="M8 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" fill="currentColor" />
          <path d="M13 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" fill="currentColor" />
          <path d="M18 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" fill="currentColor" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
          <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
          <circle cx="12" cy="10" r="4" stroke="currentColor" strokeWidth="2" />
          <path d="M4.5 18.5C7.5 15.5 16.5 15.5 19.5 18.5" stroke="currentColor" strokeWidth="2" />
        </svg>
      )}
    </div>
  );
};

export default MessageAvatar;